import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TrustedDeviceService {
  private readonly DEVICE_UUID_KEY = 'device_uuid';
  /**
   * Obtiene el UUID del dispositivo.
   * Si no existe, genera uno nuevo y lo guarda en localStorage.
   */
  getOrCreateDeviceUuid(): string {
    let uuid = localStorage.getItem(this.DEVICE_UUID_KEY);

    if (!uuid) {
      uuid = crypto.randomUUID();
      localStorage.setItem(this.DEVICE_UUID_KEY, uuid);
    }

    return uuid;
  }

  /**
   * Genera el hash SHA-256 para identificar el dispositivo.
   * Fórmula: SHA256( UUID | UserID | UserAgent )
   *
   * @param userId - El ID del usuario actual
   */
  async generateDeviceHash(): Promise<string> {
    const uuid = this.getOrCreateDeviceUuid();
    const userAgent = navigator.userAgent;
    const rawString = `${uuid}|${userAgent}`;
    const encoder = new TextEncoder();
    const data = encoder.encode(rawString);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    return this.bufferToHex(hashBuffer);
  }

  /**
   * Convierte un ArrayBuffer a una cadena Hexadecimal
   */
  private bufferToHex(buffer: ArrayBuffer): string {
    const byteArray = new Uint8Array(buffer);
    return Array.from(byteArray)
      .map((byte) => byte.toString(16).padStart(2, '0'))
      .join('');
  }
}
